export default "__VITE_ASSET__CiafaR58__"